import Vue from 'vue';
import get from 'lodash.get';

export const state = () => ({
  tender: null,
});

export const mutations = {
  setTender(state, tender) {
    state.tender = tender;
  },
  changeTender(state, { key, value }) {
    Vue.set(state.tender, key, value);
  },
  deleteFile(state, index) {
    const updatedFiles = [...state.tender.files];
    updatedFiles.splice(index, 1);
    const updatedFileIds = [...state.tender.file_ids];
    updatedFileIds.splice(index, 1);
    Vue.set(state.tender, 'files', updatedFiles);
    Vue.set(state.tender, 'file_ids', updatedFileIds);
  },
  addContractor(state, contractor) {
    const newContractorTeamId = contractor.contractor_team?.id;
    const offerIndex = state.tender.offers.findIndex(
      (offer) => offer.contractor_team.id === newContractorTeamId
    );
    if (offerIndex > -1) {
      state.tender.offers[offerIndex].contractor_responsible_users.push(
        ...contractor.contractor_responsible_users
      );
    } else {
      Vue.set(state.tender, 'offers', [...state.tender.offers, contractor]);
    }
  },
  editContractor(state, { contractor, idx }) {
    Vue.set(state.tender.offers, idx, contractor);
  },
  deleteContractor(state, idx) {
    state.tender.offers.splice(idx, 1);
  },
  deleteContractorById(state, { teamId, contractorId }) {
    const offerIndex = state.tender.offers.findIndex(
      (offer) => offer.contractor_team.id === teamId
    );
    const currentContacts = state.tender.offers[offerIndex].contractor_responsible_users;
    state.tender.offers[offerIndex].contractor_responsible_users = currentContacts.filter(
      (contact) => contact.id !== contractorId
    );
  },
};

export const actions = {
  addContractor({ commit }, contractor) {
    commit('addContractor', contractor);
  },
  deleteFile({ commit }, index) {
    commit('deleteFile', index);
  },
};

export const getters = {
  editId: (state) => {
    return get(state.tender, 'id', null);
  },
};

export default { namespaced: true, state, mutations, actions, getters };
